module.exports = __webpack_public_path__ + "img/join_img3.8dd5774b.jpg";